import PricingBlock from '@/components/pricing/PricingBlock';
import React from 'react';
import { pricing } from '../lib/pricing';
import VariablePricingBlock from '@/components/pricing/VariablePricingBlock';
import ShowcaseCard from '@/components/ui/v1/Cards/ShowcaseCard';
import SenjaTweets from '@/components/app/SenjaTweets';
import Faq from '@/components/ui/HowItWorks/Faq';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';
import { NextSeo } from 'next-seo';

export default function Pricing() {

  const [isUpgradeFromDash, setIsUpgradeFromDash] = React.useState(false);

  // detect if there is a query param upgrade-from-dash=true
  React.useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
    const upgradeFromDash = urlParams.get('upgrade-from-dash');
    if (upgradeFromDash === 'true') {
      setIsUpgradeFromDash(true);
    }
    } catch (error) {
      
    }
    
  }
  , [typeof window !== 'undefined' && window.location.search]);
  return (
    <section className="relative mt-32">
       <NextSeo
        title={'Pricing'}
        description={'Custom plans that fit your scale'}
        openGraph={{
          title: 'Pricing',
          description: 'Custom plans that fit your scale',
        }}
      />
      {/* Radial gradient */}
      <div
        className="absolute inset-0 overflow-hidden pointer-events-none -z-10"
        aria-hidden="true"
      >
        <div className="absolute flex items-center justify-center top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 w-1/3 aspect-square">
          <div className="absolute inset-0 translate-z-0 bg-primary rounded-full blur-[120px] opacity-50" />
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20">
          {/* Content */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <div>
              <div className="inline-flex font-medium bg-clip-text text-transparent bg-gradient-to-r from-primary to-purple-200 pb-3">
                Pricing plans
              </div>
            </div>
            <h2 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-white to-slate-200/75 pb-4">
              Custom plans that fit your scale
            </h2>
          </div>
          <div className="flex flex-col md:max-w-7xl mx-auto w-full max-w-5xl px-6">
            <div className="mx-auto w-full max-w-[900px]">
              <div className="flex w-full flex-col gap-6 md:flex-row">
                <PricingBlock pricingUnit={pricing[3]} hideGetStarted={isUpgradeFromDash} />
                {/* <VariablePricingBlock pricingUnit={pricing[1]} /> */}
                <PricingBlock pricingUnit={pricing[4]} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="credits" className="-mt-[100px] pt-[100px] bg-clip-content" />
      <div
        id="credits"
        className="mt-10 px-10 py-5 sm:p-0 mb-20 max-w-5xl flex flex-col items-start justify-center sm:pt-0 mx-auto "
      >
        <h2 className="text-2xl sm:text-3xl  self-start">Message Credits</h2>
        <p className="text-gray-400 mt-2 max-w-xl">
          On a per month basis. You can switch models at anytime. Each message is one query and response.
        </p>
        {/* Basically a table showing the different pricing tiers for message credits for gpt3.5, gpt4, claude 2, custom model */}
        <Table className="mt-6 w-full lg:w-[58%]">
          <TableHeader>
            <TableRow>
              <TableHead>Model / Feature</TableHead>
              <TableHead className="text-end">Credits per message</TableHead>
              {/* <TableHead className='text-end'>Free Plan</TableHead> */}
              {/* <TableHead className='text-end'>Pro Plan</TableHead> */}
            </TableRow>
          </TableHeader>
          <TableBody>
          
            <TableRow>
              <TableCell className="font-medium">{'GPT-4 (Default)'}</TableCell>
              <TableCell className="text-right">{'3'}</TableCell>
              {/* <TableCell className="text-right">{"33 messages"}</TableCell>
            <TableCell className="text-right">{"167 messages"}</TableCell> */}
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">{'Tool Used'}</TableCell>
              <TableCell className="text-right">{'3'}</TableCell>
              {/* <TableCell className="text-right">{"33 messages"}</TableCell>
            <TableCell className="text-right">{"167 messages"}</TableCell> */}
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">{'Claude-2'}</TableCell>
              <TableCell className="text-right">{'2'}</TableCell>
              {/* <TableCell className="text-right">{"50 messages"}</TableCell>
            <TableCell className="text-right">{"250 messages"}</TableCell> */}
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">{'GPT-3.5-Turbo'}</TableCell>
              <TableCell className="text-right">{'1'}</TableCell>
              {/* <TableCell className="text-right">{"100 messages"}</TableCell>
            <TableCell className="text-right">{"500 messages"}</TableCell> */}
            </TableRow>

            <TableRow>
              <TableCell className="font-medium">{'Custom'}</TableCell>
              <TableCell className="text-right">{'Custom'}</TableCell>
              {/* <TableCell className="text-right">{"Custom"}</TableCell>
            <TableCell className="text-right">{"Custom"}</TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div className="px-10 py-5 sm:p-0 mb-8 max-w-5xl flex flex-col items-center justify-center sm:pt-0 mx-auto ">
        <h2 className="text-2xl sm:text-3xl  mb-8 self-start">
          Trusted by amazing companies
        </h2>
        <div className="mt-4 grid grid-cols-1 gap-x-12 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
        <ShowcaseCard
                    title="Snap"
                    url="https://docs.snap.com/"
                    description="Mendable powers an AI chat assistant in Snap's AR documentation"
                    image="/snap-white.png"
                  />
          <ShowcaseCard
            title="Langchain"
            url="https://python.langchain.com"
            description="One of the most popular frameworks for developing AI applications"
            image="/langchain.png"
          />
          <ShowcaseCard
            title="0x"
            url="https://0x.org/docs"
            description="0x offers the core building blocks to create the most powerful Web3 apps"
            image="/0xlogo.png"
          />

          {/* <ShowcaseCard
              title="FrontMatter Docs"
              url="https://frontmatter.codes/docs"
              description="A Headless CMS right in your code editor."
              image="/frontmatter.png"
            /> */}

          {/* <ShowcaseCard
              title="Devtools AI"
              url="https://www.codegpt.co/"
              description="AI inside your IDE with this open source extension"
              image="/codegpt.png"
            />
            <ShowcaseCard
              title="Ideal Postcodes"
              url="https://www.codegpt.co/"
              description="AI inside your IDE with this open source extension"
              image="/codegpt.png"
            /> */}
        </div>
        <p className="mt-20 text-gray-400 self-center">And many more...</p>
      </div>
      <div className="my-20">
        <SenjaTweets />
      </div>
      <Faq />
    </section>
  );
}
